// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"W1-z","displaySixCardTiles":"X1-z"};